/**
 * useOsagoValidationRules
 *
 * Чистый модуль валидации — без состояния, без сайд-эффектов.
 * Возвращает объект rules, совместимый с Vuetify v-text-field :rules.
 */
export function useOsagoValidationRules() {
  const rules = {
    /** Водительское удостоверение: цифровая серия (99АА 000000) или буквенная (АА 000000) */
    license: (v) => {
      if (!v) return true
      return (
        /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) ||
        /^[A-Za-zА-Яа-яЁё]{2} \d{6}$/.test(v) ||
        'Неверный формат'
      )
    },

    /** Только русские буквы и цифры (для гос. номера) */
    russianOnly: (v) => {
      if (!v) return true
      return !(/[^А-Я0-9]/.test(v)) || 'Допускаются только русские буквы'
    },

    /** Формат российского гос. номера */
    numberRule: (v) => {
      if (!v) return true
      return (
        /^[АВЕКМНОРСТУХ][\d]{3}[АВЕКМНОРСТУХ]{2}[\d]{2,3}$/.test(v) ||
        'Неверный формат'
      )
    },

    /** ПТС серия и номер */
    pts: (v) => {
      if (!v) return true
      return (
        /^\d{2}[\dА-ЯA-Z]{2} \d{6}$/.test(v) ||
        /^[A-Za-zА-Яа-яЁё]{2} \d{6}$/.test(v) ||
        'Неверный формат'
      )
    },

    /** ЭПТС — 15 цифр */
    srts: (v) => {
      if (!v) return true
      return /^\d{15}$/.test(v) || 'Неверный формат'
    },

    /**
     * Фабрика: новое значение не должно совпадать со старым.
     * @param {string} oldValue
     */
    differentFromOld: (oldValue) => (v) => {
      if (!v) return true
      if (v === oldValue) return 'Новое значение не должно совпадать со старым'
      return true
    },
  }

  return { rules }
}



// WEBPACK FOOTER //
// ./resources/js/components/change/composables/useOsagoValidationRules.js